import React from 'react';
import PropTypes from 'prop-types';

function YoutubeIcon({ color = 'black', width = 24, height = 20 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8743 4.16116C20.7857 3.81349 20.5337 3.55099 20.2455 3.47049C19.7357 3.32699 17.2507 3.00033 12.0007 3.00033C6.75065 3.00033 4.26798 3.32699 3.75348 3.47049C3.46882 3.54982 3.21682 3.81233 3.12698 4.16116C2.99982 4.65582 2.66732 6.72899 2.66732 10.0003C2.66732 13.2717 2.99982 15.3437 3.12698 15.8407C3.21565 16.1872 3.46765 16.4497 3.75465 16.529C4.26798 16.6737 6.75065 17.0003 12.0007 17.0003C17.2507 17.0003 19.7345 16.6737 20.2478 16.5302C20.5325 16.4508 20.7845 16.1883 20.8743 15.8395C21.0015 15.3448 21.334 13.267 21.334 10.0003C21.334 6.73366 21.0015 4.65699 20.8743 4.16116ZM23.1342 3.58133C23.6673 5.66033 23.6673 10.0003 23.6673 10.0003C23.6673 10.0003 23.6673 14.3403 23.1342 16.4193C22.8378 17.5685 21.971 18.4727 20.8732 18.7783C18.8793 19.3337 12.0007 19.3337 12.0007 19.3337C12.0007 19.3337 5.12548 19.3337 3.12815 18.7783C2.02565 18.468 1.15998 17.565 0.867151 16.4193C0.333984 14.3403 0.333984 10.0003 0.333984 10.0003C0.333984 10.0003 0.333984 5.66033 0.867151 3.58133C1.16348 2.43216 2.03032 1.52799 3.12815 1.22233C5.12548 0.666992 12.0007 0.666992 12.0007 0.666992C12.0007 0.666992 18.8793 0.666992 20.8732 1.22233C21.9757 1.53266 22.8413 2.43566 23.1342 3.58133ZM9.66732 14.0837V5.91699L16.6673 10.0003L9.66732 14.0837Z"
        fill={color}
      />
    </svg>
  );
}

YoutubeIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default YoutubeIcon;
